export { renderCardHeader_unstable as renderCardHeader } from '@fluentui/react-card';
